<template>
	<div>
		<div>
			<h2 class="mb-4 font-bold">{{ type }} {{ $t('Usuario') }}</h2>
			<div class="lg:flex">
				<div class="lg:pr-5 lg:w-3/6 mb-4">
					<label class="block mb-2" for="name">{{ $t('Nombre') }}</label>
					<input type="text" v-model="user.name" id="name" class="
							w-full
							border-t-0
							border-r-0
							border-l-0
							border-b
							border-solid
							border-inputGrey
							outline-none
						" />
					<div v-if="$v.user.name.$dirty">
						<div class="text-sm text-red-500 mt-2" v-if="!$v.user.name.required">
							{{ $t('name_required') }}
						</div>
						<div class="text-sm text-red-500 mt-2" v-if="!$v.user.name.maxLength">
							{{ $t('name_validation') }}
						</div>
					</div>
				</div>
				<div class="lg:pl-5 lg:w-3/6 mb-4">
					<label class="block mb-2" for="lastname">{{ $t('Apellido') }}</label>
					<input type="text" v-model="user.lastname" id="lastname" class="
							w-full
							border-t-0
							border-r-0
							border-l-0
							border-b
							border-solid
							border-inputGrey
							outline-none
						" />
					<div v-if="$v.user.lastname.$dirty">
						<div class="text-sm text-red-500 mt-2" v-if="!$v.user.lastname.required">
							{{ $t('lastname_requerid') }}
						</div>
						<div class="text-sm text-red-500 mt-2" v-if="!$v.user.lastname.maxLength">
							{{ $t('lastname_validation') }}
						</div>
					</div>
				</div>
			</div>
			<div class="lg:flex">
				<div class="lg:pr-5 mb-4 lg:w-3/6">
					<label class="block mb-2" for="name">{{ $t('Email') }}</label>
					<input type="email" v-model="user.email" id="email" class="
							w-full
							border-t-0
							border-r-0
							border-l-0
							border-b
							border-solid
							border-inputGrey
							outline-none
						" />
					<div v-if="$v.user.email.$dirty">
						<div class="text-sm text-red-500 mt-2" v-if="!$v.user.email.required">
							{{ $t('email_required') }}
						</div>
						<div class="font-12 text-red-500 mt-2" v-if="!$v.user.email.email">
							{{ $t('email_invalido') }}
						</div>
					</div>
				</div>
				<div class="lg:pl-5 lg:w-3/6 mb-4">
					<label class="block mb-2" for="password">{{ $t('password') }}</label>
					<input type="text" v-model="user.password" id="password" class="
							w-full
							border-t-0
							border-r-0
							border-l-0
							border-b
							border-solid
							border-inputGrey
							outline-none
						" />
					<div v-if="$v.user.password.$dirty">
						<div class="text-sm text-red-500 mt-2" v-if="!$v.user.password.required">
							{{ $t('password_requerida') }}
						</div>
						<div class="text-sm text-red-500 mt-2" v-if="!$v.user.password.minLength">
							{{ $t('password_invalid') }}
						</div>
					</div>
				</div>
			</div>
			<div class="lg:flex">
				<div class="lg:pr-5 lg:w-3/6 mb-4">
					<label class="block mb-2" for="mobile">{{ $t('mobile') }}</label>
					<input type="number" v-model="user.mobile" id="mobile" class="
							w-full
							border-t-0
							border-r-0
							border-l-0
							border-b
							border-solid
							border-inputGrey
							outline-none
						" />
				</div>
				<div class="lg:pl-5 lg:w-3/6 mb-4">
					<label class="block mb-2" for="phone">{{ $t('Telefono') }}</label>
					<input type="number" v-model="user.phone" id="phone" class="
							w-full
							border-t-0
							border-r-0
							border-l-0
							border-b
							border-solid
							border-inputGrey
							outline-none
						" />
				</div>
			</div>

			<div class="lg:flex">
				<div class="lg:pr-5 lg:w-3/6 mb-4">
					<label class="block mb-2" for="rol_id">{{ $t('Roles') }}</label>
					<select id="rol_id" v-model="user.rol_id" class="
							w-full
							border-t-0
							border-r-0
							border-l-0
							border-b
							border-solid
							border-inputGrey
							outline-none
						">
						<option v-for="(rol, index) in roles" :value="rol.id" :key="index">
							{{ rol.name }}
						</option>
					</select>
					<div v-if="$v.user.rol_id.$dirty">
						<div class="text-sm text-red-500 mt-2" v-if="!$v.user.rol_id.required">
							{{ $t('roles_required') }}
						</div>
					</div>
				</div>
				<div class="lg:pl-5 lg:w-3/6 mb-4">
					<label class="block mb-2">{{ $t('DNI / NIE') }}</label>
					<input type="text" v-model="user.dni" class="
							w-full
							border-t-0
							border-r-0
							border-l-0
							border-b
							border-solid
							border-inputGrey
							outline-none
						" />
				</div>
			</div>

			<div class="lg:flex">
				<div class="mb-4 lg:w-3/6 lg:pr-5">
					<label class="block mb-2" for="organization">{{
							$t('Organizacion')
					}}</label>
					<select id="organization" v-model="user.organization_id" class="
							w-full
							border-t-0
							border-r-0
							border-l-0
							border-b
							border-solid
							border-inputGrey
							outline-none
						">
						<option v-for="(organization, index) in organizations" :value="organization.id" :key="index">
							{{ organization.name }}
						</option>
					</select>
				</div>
				<div class="mb-4 lg:w-3/6 lg:pl-5">
					<label class="block mb-2" for="delegation">{{
							$t('Delegation')
					}}</label>
					<select id="delegation" v-model="user.delegation_id" class="
							w-full
							border-t-0
							border-r-0
							border-l-0
							border-b
							border-solid
							border-inputGrey
							outline-none
						">
						<option v-for="(delegation, index) in delegations" :value="delegation.id" :key="index">
							{{ delegation.delegation_name }}
						</option>
					</select>
				</div>
			</div>
			<div class="lg:flex">
				<div class="mb-4 lg:w-3/6 lg:pr-5">
					<label class="block mb-2" for="office_id">{{ $t('office') }}</label>
					<select id="office_id" v-model="user.office_id" class="
							w-full
							border-t-0
							border-r-0
							border-l-0
							border-b
							border-solid
							border-inputGrey
							outline-none
						">
						<option v-for="(office, index) in offices" :value="office.id" :key="index">
							{{ office.office_name }}
						</option>
					</select>
				</div>
				<div class="mb-4 lg:w-3/6 lg:pl-5">
					<label class="block mb-2" for="team_id">{{ $t('team') }}</label>
					<select id="team_id" v-model="user.team_id" class="
							w-full
							border-t-0
							border-r-0
							border-l-0
							border-b
							border-solid
							border-inputGrey
							outline-none
						">
						<option v-for="(team, index) in teams" :value="team.id" :key="index">
							{{ team.team_name }}
						</option>
					</select>
				</div>
			</div>

			<div class="lg:flex">
				<div class="mb-4 lg:w-3/6 lg:pr-5">
					<label class="block mb-2" for="country_id">País</label>
					<select ref="country_id" id="country_id" v-model="user.country_id" class="
							w-full
							border-t-0
							border-r-0
							border-l-0
							border-b
							border-solid
							border-inputGrey
							outline-none
						">
						<option v-for="(country, index) in countries" :value="country.id" :key="index">
							{{ country.name }}
						</option>
					</select>
				</div>

				<div class="mb-4 lg:w-3/6 lg:pl-5">
					<label class="block mb-2" for="address_state_id">{{
							$t('state')
					}}</label>
					<select id="address_state_id" v-model="user.address_state_id" class="
							w-full
							border-t-0
							border-r-0
							border-l-0
							border-b
							border-solid
							border-inputGrey
							outline-none
						">
						<option v-for="(state, index) in states" :value="state.id" :key="index">
							{{ state.name }}
						</option>
					</select>
				</div>
			</div>

			<div class="lg:flex">
				<div class="lg:pr-5 lg:w-3/6 mb-4">
					<label class="block mb-2" for="address">{{ $t('address') }}</label>
					<input type="text" maxlength="200" v-model="user.address" id="address" class="
							w-full
							border-t-0
							border-r-0
							border-l-0
							border-b
							border-solid
							border-inputGrey
							outline-none
						" />
				</div>

				<div class="mb-4 lg:w-3/6 lg:pl-5">
					<label class="block mb-2" for="address_zipcode">{{
							$t('zipcode')
					}}</label>
					<input type="text" maxlength="20" v-model="user.address_zipcode" id="address_zipcode" class="
							w-full
							border-t-0
							border-r-0
							border-l-0
							border-b
							border-solid
							border-inputGrey
							outline-none
						" />
				</div>
			</div>

			<div class="mt-4 flex justify-end">
				<!-- <ButtonBlack class="mr-2" @click.native="onResetPassword" v-if="id">
          <div>
            {{$t("reset_password")}}
          </div>
        </ButtonBlack> -->
				<ButtonBlack @click.native="submit">
					<div v-if="loading">
						<pulse-loader :loading="loading" :color="'#fff'" :size="'10px'"></pulse-loader>
					</div>
					<div v-else>
						{{ buton_text }}
					</div>
				</ButtonBlack>
			</div>
			<div v-if="error" class="mt-4">
				<p class="text-sm">{{ $t('server_error') }}</p>
				<p class="text-sm text-red-500" v-html="server_error"></p>
			</div>
		</div>
	</div>
</template>

<script>
import { required, maxLength, minLength, email } from 'vuelidate/lib/validators'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import { single } from '@/mixins'

import { fetchCountriesSelect } from '@/apollo/countries'
import { fetchRolesSelect } from '@/apollo/roles'
import { fetchOrganizationsSelect } from '@/apollo/organizations'
import { fetchDelegationsSelect } from '@/apollo/delegations'
import { fetchOfficesSelect } from '@/apollo/offices'
import { fetchTeamsSelect } from '@/apollo/teams'
import { fetchStatesSelect } from '@/apollo/states'
import { fetchUser } from '@/apollo/users'
import { insertUser } from '@/apollo/users'
import { updateUser } from '@/apollo/users'

export default {
	mixins: [single],
	components: { PulseLoader },
	data() {
		return {
			user: {
				name: '',
				lastname: '',
				email: '',
				dni: null,
				mobile: '',
				phone: '',
				password: null,
				country_id: null,
				rol_id: null,
				organization_id: null,
				delegation_id: null,
				office_id: null,
				team_id: null,
				address: null,
				address_state_id: null,
				address_zipcode: null
			},
			roles: [],
			organizations: [],
			delegations: [],
			offices: [],
			teams: [],
			countries: [],
			states: []
		}
	},
	apollo: {
		roles: fetchRolesSelect(),
		organizations: fetchOrganizationsSelect(),
		delegations: fetchDelegationsSelect(),
		offices: fetchOfficesSelect(),
		teams: fetchTeamsSelect(),
		countries: fetchCountriesSelect(),
		states: fetchStatesSelect(),
		user() {
			return fetchUser(this.id)
		}
	},
	watch: {
		'user.organization_id': function (organization_id) {
			this.$apollo.queries.delegations.refetch({
				organization_id
			})
			this.$apollo.queries.delegations.skip = false
			this.offices = []
			this.teams = []
		},
		'user.delegation_id': function (delegation_id) {
			this.$apollo.queries.offices.refetch({ delegation_id })
			this.$apollo.queries.offices.skip = false
			this.$apollo.queries.teams.refetch({ delegation_id })
			this.$apollo.queries.teams.skip = false
		},
		'user.email': function (newValue) {
			this.user.email = newValue.toLowerCase()
		}
	},
	methods: {
		updateSingleUser() {
			return this.$apollo.mutate(
				updateUser(this.id, {
					name: this.user.name,
					lastname: this.user.lastname,
					email: this.user.email,
					password: this.user.password,
					mobile: this.user.mobile,
					phone: this.user.phone,
					rol_id: this.user.rol_id,
					dni: this.user.dni,
					office_id: this.user.office_id,
					team_id: this.user.team_id,
					country_id: this.user.country_id,
					address_state_id: this.user.address_state_id,
					address: this.user.address,
					address_zipcode: this.user.address_zipcode
				})
			)
		},
		insertSingleUser() {
			return this.$apollo.mutate(
				insertUser({
					name: this.user.name,
					lastname: this.user.lastname,
					email: this.user.email.toLowerCase(),
					password: this.user.password,
					mobile: this.user.mobile,
					phone: this.user.phone,
					rol_id: this.user.rol_id,
					dni: this.user.dni,
					office_id: this.user.office_id,
					team_id: this.user.team_id,
					country_id: this.user.country_id,
					address_state_id: this.user.address_state_id,
					address: this.user.address,
					address_zipcode: this.user.address_zipcode
				})
			)
		},
		submit() {
			this.startLoadingState()
			this.$v.$touch()
			if (!this.$v.$invalid) {
				; (this.id ? this.updateSingleUser() : this.insertSingleUser())
					.then(() => {
						this.stopLoadingState()
						this.id ? this.$alert("Tu usuario está actualizado", "¡Enhorabuena!", "success") : this.$alert("Su usuario ha sido creado", "¡Enhorabuena!", "success")
					})
					.catch(error => {
						this.setError(error)
						this.$alert(error, "Error", "error")
					})
			} else {
				this.setError(this.$t('form_validation'))
				this.$alert(this.$t('form_validation'), "Advertencia", "warning")
			}
		}
	},
	validations() {
		const validations = {
			user: {
				name: {
					required,
					maxLength: maxLength(50)
				},
				email: {
					required,
					email
				},
				lastname: {
					required,
					maxLength: maxLength(50)
				},
				rol_id: {
					required
				}
			}
		}
		validations.user.password = {
			required,
			minLength: minLength(8)
		}
		return validations
	}
}
</script>
